import React, { useEffect } from 'react';
import { loadElementsDoc } from '@/utils/loadElementsDoc';

export default function OpenApiElements({ apiDescriptionUrl }) {
  useEffect(() => {
    let cancelled = false;

    loadElementsDoc().then(() => {
      if (cancelled) return;
      const ele = document.getElementById('elements');
      if (!ele || ele.querySelector('elements-api')) return;

      const tag = document.createElement('elements-api');
      tag.setAttribute('apiDescriptionUrl', apiDescriptionUrl);
      tag.setAttribute('router', 'hash');
      tag.setAttribute('hideSchemas', true);
      ele.append(tag);

      setTimeout(() => {
        const border = document.querySelector('.sl-border-t');
        if (border) border.style.display = 'none';
      }, 1000);
    });

    return () => {
      cancelled = true;
    };
  }, [apiDescriptionUrl]);

  return <div id="elements" />;
}
